import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/tools')({
  component: RouteComponent,
});

/**
 * Layout route for tools - renders nested routes via Outlet
 */
function RouteComponent() {
  return <Outlet />;
}
